import React, { useEffect, useState } from "react";
import { MATERIAL_TYPES } from "../lib/constants";

/**
 * Multi-select pills for material types + "أخرى" option with inline text input.
 * Value is an array of strings. Predefined items render as pills; any extra string
 * in the array that's NOT in MATERIAL_TYPES is treated as the "أخرى" custom value.
 */
const MaterialSelector = ({ value = [], onChange, testidPrefix = "material" }) => {
  const predefinedSelected = value.filter((m) => MATERIAL_TYPES.includes(m));
  const customInitial = value.find((m) => !MATERIAL_TYPES.includes(m)) || "";
  const [otherOn, setOtherOn] = useState(!!customInitial);
  const [custom, setCustom] = useState(customInitial);

  // When parent value changes externally, sync
  useEffect(() => {
    const ci = value.find((m) => !MATERIAL_TYPES.includes(m)) || "";
    setCustom(ci);
    setOtherOn(!!ci);
  }, [JSON.stringify(value)]); // eslint-disable-line

  const emit = (preds, isOtherOn, customText) => {
    const out = [...preds];
    const t = (customText || "").trim();
    if (isOtherOn && t) out.push(t);
    onChange(out);
  };

  const togglePredefined = (m) => {
    const next = predefinedSelected.includes(m)
      ? predefinedSelected.filter((x) => x !== m)
      : [...predefinedSelected, m];
    emit(next, otherOn, custom);
  };

  const toggleOther = () => {
    const next = !otherOn;
    setOtherOn(next);
    if (!next) { setCustom(""); emit(predefinedSelected, false, ""); }
    else { emit(predefinedSelected, true, custom); }
  };

  const onCustomChange = (v) => {
    setCustom(v);
    emit(predefinedSelected, otherOn, v);
  };

  return (
    <div className="space-y-3" data-testid={`${testidPrefix}-selector`}>
      <div className="flex flex-wrap gap-2">
        {MATERIAL_TYPES.map((m) => {
          const active = predefinedSelected.includes(m);
          return (
            <button type="button" key={m} onClick={() => togglePredefined(m)}
              data-testid={`${testidPrefix}-${m}`}
              className={`h-10 px-4 rounded-full border-2 font-bold text-sm transition-colors ${active ? "bg-[#09637E] text-white border-[#09637E]" : "bg-white text-[#09637E] border-[#7AB2B2] hover:border-[#09637E]"}`}>
              {m}
            </button>
          );
        })}
        <button type="button" onClick={toggleOther}
          data-testid={`${testidPrefix}-other`}
          className={`h-10 px-4 rounded-full border-2 font-bold text-sm transition-colors ${otherOn ? "bg-[#088395] text-white border-[#088395]" : "bg-white text-[#088395] border-dashed border-[#7AB2B2] hover:border-[#088395]"}`}>
          + أخرى
        </button>
      </div>
      {otherOn && (
        <input
          type="text"
          value={custom}
          onChange={(e) => onCustomChange(e.target.value)}
          placeholder="اكتب نوع المادة (مثل: رخام صناعي، حجر طبيعي)"
          data-testid={`${testidPrefix}-custom-input`}
          maxLength={50}
          className="h-11 w-full rounded-lg border border-[#088395] bg-white px-4 focus:outline-none focus:ring-2 focus:ring-[#09637E]"
        />
      )}
    </div>
  );
};

export default MaterialSelector;
